import { Heading } from '@postscript/components';
import { useState } from 'react';
import styled from 'styled-components';
import { CreateFlowViews } from '../constants';
import { useFlowCreation } from '../hooks/useFlowCreation';
import {
  CreateFlowView,
  FlowType,
  FlowWizardOptionsType,
  SubmitCreateFlowArgs,
} from '../types';
import CreateFlowGrid from './CreateFlowGrid';
import ChooseFlowTemplateForm from './forms/ChooseFlowTemplateForm';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
`;

export default function CreateFlowWizard({
  variant = 'modal',
  flowType,
  onCancel,
}: {
  variant?: 'modal' | 'page';
  flowType: FlowType;
  onCancel?: (from?: FlowWizardOptionsType) => void;
}) {
  const [view, setView] = useState<CreateFlowView>(CreateFlowViews.INITIAL);

  const { createFlow } = useFlowCreation();

  const handleSubmit = (args?: SubmitCreateFlowArgs) => {
    const result = createFlow(args);

    // Handle special case where modal should be closed
    if (result?.shouldCloseModal && onCancel) {
      onCancel(result.from);
    }
  };

  return (
    <StyledWrapper>
      {variant === 'modal' && (
        <Heading size="small">
          {' '}
          {view === CreateFlowViews.INITIAL
            ? 'Choose where to start'
            : 'Choose a template'}
        </Heading>
      )}
      {view === CreateFlowViews.CHOOSE_TEMPLATE ? (
        <ChooseFlowTemplateForm
          flowType={flowType}
          handleSubmit={handleSubmit}
          onBack={() => setView(CreateFlowViews.INITIAL)}
          variant={variant}
        />
      ) : (
        <CreateFlowGrid
          flowType={flowType}
          handleSubmit={handleSubmit}
          onChooseTemplate={() => setView(CreateFlowViews.CHOOSE_TEMPLATE)}
          variant={variant}
        />
      )}
    </StyledWrapper>
  );
}
